'use client';

import { H1, P } from './styleConstants';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import CustomLink from 'components/shared/CustomLink';
import { SplineViewer } from 'components/shared/SplineViewer/SplineViewer';
import styles from './HeroSection.module.css';

export const BloodVision_HeroSection = ({
  className,
}: {
  className?: string;
}) => {
  const { region: country } = useRegionLocale();

  return (
    <section
      className={className ? `${styles.root} ${className}` : styles.root}
    >
      <div className={styles.canvasContainer}>
        <SplineViewer
          desktopSrc="/js/scene-bv.splinecode"
          mobileSrc="/js/scene-bv-responsive.splinecode"
        />
      </div>
      {/* <Container className="bv-hero-content">
          <div className="main-content">
            <H1>
              Introducing
              <br />
              Blood Vision
            </H1>
            <P>
              Discover the world of Blood Vision, a new and exciting NFT
              collection.
            </P>
          </div>
          <div className="secondary-content">

          </div>
        </Container> */}

      <div className={styles.mainContent}>
        <H1>
          Introducing
          <br />
          Blood Vision
        </H1>
        <P>
          Decoding the Language of Blood with UltraTrace
          <span style={{ opacity: '0.5' }}>™</span>
        </P>
        <div className={styles.ctaContainer}>
          <CustomLink href="/blood-vision/buy">Book test</CustomLink>
        </div>
        {country !== 'IN' && country !== 'US' ? (
          <p className={styles.comingDisclaimer}>
            Coming to your location soon
          </p>
        ) : null}
      </div>
    </section>
  );
};
